
































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Api from "@/api";
import { IFacility, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

@Component
export default class Venues extends Vue {
  @Prop({ default: false }) readonly active!: boolean;

  private venues: Array<IVenue> = [];
  private totalCount = 0;
  private facilities: Array<IFacility> = [];
  private isVenuesOnFirstLevel = false;
  private venues_menu_template: string | null = null;

  private created(): void {
    this.venues_menu_template = this.$appConfigs().venues_menu_template;
  }

  @Watch("venues_menu_template")
  venues_menu_template_changed(template: string | null): void {
    if (!template) return;
    const endpoint: string = this.$partnerEndpoint(
      "venues/menu-templates/" + template
    );
    this.isVenuesOnFirstLevel = template.split("_")[0] === "venues";

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        if (this.isVenuesOnFirstLevel) {
          if (template === "venues_on_first_level") {
            const allVenues: Array<IVenue> = [];
            response.data.data.map((venue: IVenue) => {
              allVenues.push({ id: venue.id, name: venue.name });
              if (venue.child_venues && venue.child_venues.length) {
                venue.child_venues.map(childVenue => {
                  allVenues.push(childVenue);
                });
              }
            });
            this.venues = allVenues;
            this.totalCount = this.venues.length;
          } else {
            this.venues = response.data.data;
            this.totalCount = this.venues.length;
            this.venues.map(venue => {
              if (venue.child_venues && venue.child_venues.length) {
                this.totalCount += venue.child_venues.length;
              }
            });
          }
        } else {
          this.facilities = response.data.data;
          this.totalCount = 0;
          this.facilities.map((facility: IFacility) => {
            this.totalCount += facility.venues ? facility.venues.length : 0;
          });
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
